/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { keyValueListStyle } from './KeyValueList.styles';

export interface KeyValueItem {
  key: ReactNode;
  value: ReactNode;
}

export interface KeyValueListProps {
  items: KeyValueItem[];
}

/** 키/값 나열. Job 결과 요약, 행 상세(스키마 컬럼 → 값)에 활용. */
export function KeyValueList({ items }: KeyValueListProps) {
  return (
    <dl css={keyValueListStyle}>
      {items.map((item, i) => (
        <div key={i}>
          <dt>{item.key}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
